import type {
  MoneyV2,
  ProductConnection,
} from "@shopify/hydrogen-react/storefront-api-types";

export type Modify<T, TReplace> = Omit<T, keyof TReplace> & TReplace;

export const checkForErrors = (
  data?: { [key: string]: any } | null,
  errorKey?: string
) => {
  if (!data || !errorKey) return;

  if (data[errorKey]?.length) {
    throw new Error(data[errorKey][0].code);
  }
};

interface CustomError {
  __typename?: string;
  code?: string | null;
  message: string;
  field?: Array<string> | null;
}

export const serializeErrors = (error: CustomError) => {
  if (error.message.includes("Email is invalid")) {
    return "INVALID.EMAIL";
  } else if (error.message.includes("Email has already been taken")) {
    return "EMAIL_TAKEN";
  } else if (error.message.includes("Resetting password limit exceeded")) {
    return "RESET_PASSWORD_LIMIT_EXCEEDED";
  } else if (error.message.includes("Creating Customer Limit exceeded")) {
    return "CREATION_LIMIT_EXCEEDED";
  } else if (!error.code) return error.message;
  else {
    return error.code;
  }
};

export function isNewArrival(date: string, daysOld = 30) {
  return (
    new Date(date).valueOf() >
    new Date().setDate(new Date().getDate() - daysOld).valueOf()
  );
}

export function isDiscounted(price: MoneyV2, compareAtPrice: MoneyV2) {
  if (Number(compareAtPrice.amount) > Number(price.amount)) {
    return true;
  }
  return false;
}

export function calculateDiscount(
  price: MoneyV2,
  compareAtPrice: MoneyV2
): number {
  if (compareAtPrice.amount > price.amount) {
    return Math.round(
      ((Number(compareAtPrice.amount) - Number(price.amount)) /
        Number(compareAtPrice.amount)) *
        100
    );
  }
  return 0;
}

export function flattenProducts(products: ProductConnection | undefined) {
  if (!products) return undefined;
  if (products.edges.length) return products.edges.flatMap(edge => edge.node);
  if (products.nodes.length) return products.nodes;
}

const filterSearchParams = (
  params: URLSearchParams,
  filter: string,
  value: string | Array<string>
) => {
  const currentFilterParams = params.getAll(filter);
  let temp = currentFilterParams;
  if (Array.isArray(value)) {
    value.forEach(value => {
      temp = temp.filter(param => param !== value);
    });
  } else {
    temp = temp.filter(tempValue => tempValue !== value);
  }
  params.delete(filter);
  if (temp.length) {
    temp.forEach(tempValue => {
      params.append(filter, tempValue);
    });
  }
};

export const handleProductsFilterChange = (
  params: URLSearchParams,
  filter: string,
  value: string | Array<string>,
  checked: boolean
) => {
  if (checked) {
    return filterSearchParams(params, filter, value);
  }

  if (Array.isArray(value)) {
    return value.forEach(value => {
      params.append(filter, value);
    });
  }
  params.append(filter, value);
};
